"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _core = require("@linaria/core");
/**
 * Local Imports
 */

const ContentWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentWrapper",
  class: "pl-c1ybzczu"
});
const templateDescription = "pl-t18osr64";
const ButtonContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonContainer",
  class: "pl-btckl4f"
});

/**
 * ContentItem Component.
 *
 * @param {Object} props React props
 * @param {String} props.id Item GUID
 * @param {String} props.templateId Template GUID
 * @param {String} props.name Template GUID
 * @param {String} props.description Template Description
 * @param {String} props.lid Onboarding Lid Value
 * @param {String} props.vertical Onboarding Vertical Value
 * @param {String} props.onboardingUrl Onboarding URL
 * @param {String} props.primaryCtaText Primary CTA Text
 * @param {String} props.primaryCtaAriaLabel Primary CTA Aria Label
 * @param {String} props.secondaryCtaText Secondary CTA Text
 * @param {String} props.secondaryCtaAriaLabel Secondary CTA Aria Label
 * @param {Function} props.modalFn Template Modal Trigger
 * @returns {React.ReactElement} ContentItem Component
 * @public
 */

function ContentItem({
  id,
  name,
  description,
  onboardingUrl,
  primaryCtaText = 'Start Editing',
  secondaryCtaText = 'Preview Site',
  primaryCtaAriaLabel,
  secondaryCtaAriaLabel,
  modalFn
}) {
  return /*#__PURE__*/_react.default.createElement(ContentWrapper, {
    "data-cy": "content-container"
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    className: templateDescription,
    as: "paragraph",
    size: -1
  }, /*#__PURE__*/_react.default.createElement("strong", null, name, ":"), description), /*#__PURE__*/_react.default.createElement(ButtonContainer, {
    "data-cy": "ctas"
  }, primaryCtaText && /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    _name: `launch-${name}`,
    text: primaryCtaText,
    design: "primary",
    shrinkOn: "mobile",
    size: "small",
    href: onboardingUrl,
    ariaLabel: primaryCtaAriaLabel
  }), secondaryCtaText && /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    _name: `id-${id}`,
    onClick: modalFn,
    text: secondaryCtaText,
    design: "secondary",
    size: "small",
    ariaLabel: secondaryCtaAriaLabel
  })));
}
var _default = exports.default = ContentItem;
ContentItem.propTypes = {
  id: _propTypes.default.string.isRequired,
  templateId: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  description: _propTypes.default.string,
  lid: _propTypes.default.string.isRequired,
  vertical: _propTypes.default.string.isRequired,
  onboardingUrl: _propTypes.default.string.isRequired,
  primaryCtaText: _propTypes.default.string,
  primaryCtaAriaLabel: _propTypes.default.string,
  secondaryCtaText: _propTypes.default.string,
  secondaryCtaAriaLabel: _propTypes.default.string,
  modalFn: _propTypes.default.func
};